import { SET_HAS_JOB_INFORMATION } from '../actions/hasJobInformationDataActions';

let initialState = false;

const hasJobInformationDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_HAS_JOB_INFORMATION:
            return action.payload.value
        default:
            return state;
    }
}

export default hasJobInformationDataReducer;